export default {
  eyebrow: '',
  heading: 'Neque ua porro quisq uam dolom',
  copy:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sit amet magna sed lacus maximus dictum eget eu lectus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.\n\n' +
    'Maecenas tempor nunc in commodo suscipit. Nullam non tellus est. Nulla facilisi. Sed sapien mi, condimentum ac blandit ut, pretium id metus. Phasellus interdum placerat odio ac convallis. Proin vehicula finibus volutpat. Aenean quam velit, congue in maximus molestie, accumsan in nisl. Curabitur vitae tortor magna. Duis dapibus auctor augue.',
  image: {
    alt: 'Image showing the GTI Superdrive surrounded by mountains',
    filename:
      '//a.storyblok.com/f/46530/1480x833/1d7b7efcf3/01-hero-vw-gtisuperdrives-001.png',
  },
  cta: [],
  squares: [
    {
      x: 1,
      y: 2,
      image: '',
      color_background: { color: '#C33CA8' },
      component: 'm-square',
    },
    {
      x: 2,
      y: 1,
      image: {
        alt: 'An Image',
        filename:
          '//a.storyblok.com/f/46530/1250x833/1b6066c1de/tribal_edit_v3-00_08_23_04-still023.png',
      },
      color_background: '',
      component: 'm-square',
    },
  ],
  battenberg: [
    {
      title: 'Tribal Health',
      square_1: { color: 'transparent' },
      square_2: { color: '#D1CCC4' },
      square_3: { color: 'transparent' },
      square_4: { color: '#D1CCC4' },
      square_5: { color: 'transparent' },
      square_6: { color: 'transparent' },
      square_7: { color: 'transparent' },
      square_8: { color: 'transparent' },
      square_9: { color: 'transparent' },
      component: 'a-svg-logo-x9',
    },
  ],
  component: 'o-health-x1-sq',
}
